export enum PowerBiAccessControlEntryType {
    User = 2,
    JobCode = 1,
    UserAndDirectReports = 3,
    UserAndDirectAndIndirectReports = 4
}

export const PowerBiAccessControlEntryTypeDisplayName : Record<PowerBiAccessControlEntryType, string> = {
    [PowerBiAccessControlEntryType.JobCode]: "Job Code",
    [PowerBiAccessControlEntryType.User]: "User",
    [PowerBiAccessControlEntryType.UserAndDirectReports]: "User and their direct reports",
    [PowerBiAccessControlEntryType.UserAndDirectAndIndirectReports]: "User and their direct and indirect reports",
}